import { LoadingButton } from "@mui/lab";
import { useTranslation } from "react-i18next";
import { setCompetitorAnalysis } from "../../../../../../redux/slices/competitorSlice";
import { useGetLinkTableMutation } from "../../../../../../redux/slices/postEditorBlogSlice";
import { dispatch } from "../../../../../../redux/store";
import {
  calculateBrandedColor,
  calculateKeywordsColor,
} from "../../../../seoAnalyzer/linkingHelper";
import CompetitorCard from "../../competitorAnalysisCard";

export const LinkingCompetitorAnalysis = ({
  competitorResults,
  showModalHandle,
  analysis,
  showModal,
  formikProps,
}) => {
  const { t } = useTranslation();
  const [linkingTable, { isLoading: loadingTable }] = useGetLinkTableMutation();

  const handleLinkingTable = async () => {
    const payload = {
      text:
        formikProps.values.introduction +
        formikProps.values.content +
        formikProps.values.conclusion,
      domain: formikProps.values.url_path,
    };
    const res = await linkingTable(payload).unwrap();
    if (res?.table) {
      showModalHandle({
        linkingTable: res,
        show: true,
        type: "linking",
      });
      dispatch(
        setCompetitorAnalysis({
          data: {
            ...competitorResults,
            linkingTable: res,
          },
        })
      );
    }
  };

  const handleHideLinkingTable = () => {
    showModalHandle({
      linkingTable: null,
      show: false,
      type: "linking",
    });
  };

  return (
    <>
      {" "}
      <>
        {/* Anchor Type Score */}
        {
          <div className="mt-5">
            <p className="text-sm mb-2 font-semibold">
              {" "}
              {t("Anchor_text_type_score", "Anchor text type score")}
            </p>
            <p
              className={`text-sm mb-2 font-semibold ${
                competitorResults?.linkingTable?.anchor_text_type_score >= 75 &&
                (analysis?.nb_link?.externalLinks > 0 ||
                  analysis?.nb_link?.internalLinks > 0)
                  ? "text-green-500"
                  : competitorResults?.linkingTable?.anchor_text_type_score <
                      75 &&
                    competitorResults?.linkingTable?.anchor_text_type_score >=
                      35 &&
                    (analysis?.nb_link?.externalLinks > 0 ||
                      analysis?.nb_link?.internalLinks > 0)
                  ? "text-yellow-500"
                  : competitorResults?.linkingTable?.anchor_text_type_score <
                      35 &&
                    competitorResults?.linkingTable?.anchor_text_type_score >=
                      0 &&
                    (analysis?.nb_link?.externalLinks > 0 ||
                      analysis?.nb_link?.internalLinks > 0)
                  ? "text-red-600"
                  : "text-gray_local-400"
              }`}
            >
              {" "}
              {competitorResults?.linkingTable?.anchor_text_type_score >= 75 &&
              (analysis?.nb_link?.externalLinks > 0 ||
                analysis?.nb_link?.internalLinks > 0)
                ? t(
                    "The_anchor_type_ratio_is_ideal",
                    "The anchor type ratio is ideal."
                  )
                : competitorResults?.linkingTable?.anchor_text_type_score <
                    75 &&
                  competitorResults?.linkingTable?.anchor_text_type_score >=
                    35 &&
                  (analysis?.nb_link?.externalLinks > 0 ||
                    analysis?.nb_link?.internalLinks > 0)
                ? t(
                    "The_anchor_type_ratio_is_ok",
                    "The anchor type ratio is ok."
                  )
                : competitorResults?.linkingTable?.anchor_text_type_score <
                    35 &&
                  competitorResults?.linkingTable?.anchor_text_type_score >=
                    0 &&
                  (analysis?.nb_link?.externalLinks > 0 ||
                    analysis?.nb_link?.internalLinks > 0)
                ? t(
                    "The_anchor_type_ratio_is_bad",
                    "The anchor type ratio is bad."
                  )
                : t("Please-add-content", "Please add content")}
            </p>
            {(analysis?.nb_link?.externalLinks > 0 ||
              analysis?.nb_link?.internalLinks > 0) && (
              <ul className="ps-3 list-disc list-inside text-sm font-semibold">
                <li
                  className={`${calculateKeywordsColor(
                    competitorResults?.linkingTable?.anchor_text_type_ratios
                      ?.branded,
                    competitorResults?.linkingTable?.anchor_text_type_ratios
                      ?.keywords
                  )}`}
                >
                  {t("Keywords", "Keywords")} :{" "}
                  {competitorResults?.linkingTable?.anchor_text_type_ratios?.keywords?.toFixed(
                    2
                  )}
                  %
                </li>
                <li
                  className={`${calculateBrandedColor(
                    competitorResults?.linkingTable?.anchor_text_type_ratios
                      ?.branded,
                    competitorResults?.linkingTable?.anchor_text_type_ratios
                      ?.keywords
                  )}`}
                >
                  {t("Branded", "Branded")} :{" "}
                  {competitorResults?.linkingTable?.anchor_text_type_ratios?.branded?.toFixed(
                    2
                  )}
                  %
                </li>
                <li
                  className={`${
                    competitorResults?.linkingTable?.anchor_text_type_ratios
                      ?.other > 15
                      ? "text-red-600"
                      : "text-green-500"
                  }`}
                >
                  {t("Others", "Others")}:{" "}
                  {competitorResults?.linkingTable?.anchor_text_type_ratios?.other?.toFixed(
                    2
                  )}
                  %
                </li>
                <li
                  className={`${
                    competitorResults?.linkingTable?.anchor_text_type_ratios
                      ?.empty > 0
                      ? "text-red-600"
                      : "text-green-500"
                  }`}
                >
                  {t("Empty", "Empty")} :{" "}
                  {competitorResults?.linkingTable?.anchor_text_type_ratios?.empty?.toFixed(
                    2
                  )}
                  %
                </li>
              </ul>
            )}
          </div>
        }
        {/* Anchor Length Score */}
        {
          <div className="mt-5">
            <p className="text-sm mb-2 font-semibold">
              {" "}
              {t("Anchor_length_score", "Anchor length score")}
            </p>
            <p
              className={`text-sm mb-2 font-semibold ${
                competitorResults?.linkingTable?.anchor_length_score >= 75 &&
                (analysis?.nb_link?.externalLinks > 0 ||
                  analysis?.nb_link?.internalLinks > 0)
                  ? "text-green-500"
                  : competitorResults?.linkingTable?.anchor_length_score >=
                      35 &&
                    competitorResults?.linkingTable?.anchor_length_score < 75 &&
                    (analysis?.nb_link?.externalLinks > 0 ||
                      analysis?.nb_link?.internalLinks > 0)
                  ? "text-yellow-500"
                  : analysis?.nb_link?.externalLinks > 0 ||
                    analysis?.nb_link?.internalLinks > 0
                  ? "text-red-600"
                  : "text-gray_local-400"
              }`}
            >
              {" "}
              {competitorResults?.linkingTable?.anchor_length_score >= 75 &&
              (analysis?.nb_link?.externalLinks > 0 ||
                analysis?.nb_link?.internalLinks > 0)
                ? t(
                    "The_average_length_of_your_anchors_is_perfect",
                    "The average length of your anchors is perfect."
                  )
                : competitorResults?.linkingTable?.anchor_length_score >= 35 &&
                  competitorResults?.linkingTable?.anchor_length_score < 75 &&
                  (analysis?.nb_link?.externalLinks > 0 ||
                    analysis?.nb_link?.internalLinks > 0)
                ? t(
                    "The_average_length_of_your_anchors_is_ok",
                    "The average length of your anchors is ok."
                  )
                : analysis?.nb_link?.externalLinks > 0 ||
                  analysis?.nb_link?.internalLinks > 0
                ? t(
                    "The_average_length_of_your_anchors_is_bad",
                    "The average length of your anchors is bad."
                  )
                : t("Please-add-content", "Please add content")}
            </p>
          </div>
        }
      </>
      {/* Show/Hide Link table */}
      {!showModal ? (
        <div className="text-center mt-5">
          <LoadingButton
            onClick={handleLinkingTable}
            variant="contained"
            loading={loadingTable}
            className="!text-sm hover:!bg-blue-100 *: !bg-blue-200 disabled:!text-transparent disabled:!bg-slate-100 !normal-case  !text-white font-light px-5 py-[6px] !rounded flex items-center"
          >
            {t("See_the_table_of_links", "See the table of links")}
          </LoadingButton>
        </div>
      ) : (
        <div className="text-center mt-5">
          <LoadingButton
            onClick={handleHideLinkingTable}
            variant="contained"
            loading={loadingTable}
            className="!text-sm hover:!bg-blue-100 *: !bg-blue-200 disabled:!text-transparent disabled:!bg-slate-100 !normal-case  !text-white font-light px-5 py-[6px] !rounded flex items-center"
          >
            {t("Hide_table", "Hide table")}
          </LoadingButton>
        </div>
      )}
      {/* Competitor Analysis */}
      {competitorResults && competitorResults?.analysis?.length > 0 && (
        <>
          <p className="text-white text-xl mt-6 mb-4 font-bold">
            {t("Competition", "Competition")}
          </p>
        </>
      )}
      {competitorResults &&
        competitorResults?.analysis?.map((item, index) => {
          return (
            <CompetitorCard
              type={"linking"}
              index={index}
              general={competitorResults.general}
              content={competitorResults.contents[index]}
              analysis={item}
              seoRequest={competitorResults.seo_request}
              url={competitorResults.contents[index].url}
            ></CompetitorCard>
          );
        })}
    </>
  );
};
